module.exports = __webpack_public_path__ + "img/map.272c92c3.png";